import React from 'react';
import { Helmet as HelmetBase } from 'react-helmet-async';
import { useAppSelector } from '../../../base/hooks';

interface Props {
    pageName: string;
}

export const Helmet = ({ pageName }: Props) => {
    const { seoTags } = useAppSelector((state) => state.recruiterApp.config);

    return (
        <HelmetBase>
            <title>{`${pageName} ${seoTags.title}`}</title>
            <meta name='description' content={`${pageName} ${seoTags.description}`} />
        </HelmetBase>
    );
};
